import React from 'react';

export default function AccessLevelDescriptions({ isMobile, showExtraInfo }) {
  return (
    <div className="access-info-well">
      <h4>Access Level Descriptions</h4>
      <div className="access-level-info">
        <div className="access-level" data-level="no-access">
          <span className="access-level-name">{isMobile ? 'NONE (NO ACCESS)' : 'NO ACCESS'}</span>
          <p>Users cannot see or access this specific camera system</p>
        </div>
        <div className="access-level" data-level="live-view">
          <span className="access-level-name">{isMobile ? 'LIVE (LIVE FEED ONLY)' : 'LIVE FEED ONLY'}</span>
          <p>Users can only access the camera system's live feeds</p>
        </div>
        <div className="access-level" data-level="no-sharing">
          <span className="access-level-name">{isMobile ? 'FULL (FULL ACCESS)' : 'FULL ACCESS'}</span>
          <p>Users have access to the camera system's live feeds and motion history recordings</p>
        </div>
        <div className="access-level" data-level="full-access">
          <span className="access-level-name">{isMobile ? 'ADMIN (CAMERA ADMIN)' : 'CAMERA ADMIN'}</span>
          <p>Same as Full Access, but can change camera settings and share the camera with others</p>
        </div>
        <div className="access-level" data-level="admin">
          <span className="access-level-name">{isMobile ? 'OWNER (BUILDER ADMIN)' : 'BUILDER ADMIN'}</span>
          <p>By default, a Builder Admin has Camera Admin privileges for all cameras and can additionally access this page to manage other users</p>
        </div>
      </div>
      {showExtraInfo && (
        <div className="access-info-note">
          <i className="fas fa-info-circle"></i>
          <p>Users shown in <span className="text-danger"><i className="fas fa-exclamation-circle" /> red</span> have not yet activated their account. If you click on them, you can access a page with more information including a button to resend their account activation email.</p>
        </div>
      )}
    </div>
  );
} 